/** DRM best-effort na camada da app (ADR-009 item 3).
 *
 * Bloqueia cópia, recorte, arrasto, salvar, imprimir e menu de contexto. É
 * explicitamente BEST-EFFORT: o canvas é capturável por screenshot, e isso está
 * registrado no ADR-009 para ser comunicado por escrito ao cliente (premortem
 * R6). Não se promete proteção forte.
 *
 * O que NÃO se bloqueia, de propósito: `selectstart`. A US-01 pede clipboard
 * bloqueado COM a seleção funcionando, porque é a seleção que abre o menu de
 * cores do destaque (US-05) e alimenta a leitura em voz alta. Matar a seleção
 * mataria a acessibilidade junto com a cópia.
 */
import { useEffect } from 'react'

const BLOCKED_KEYS = new Set(['c', 's', 'p', 'u'])

export function useDRM(enabled = true): void {
  useEffect(() => {
    if (!enabled) return

    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && BLOCKED_KEYS.has(event.key.toLowerCase())) {
        event.preventDefault()
      }
    }
    // Arrastar a seleção para outra aba é uma cópia; recortar também.
    const bloquear = (event: Event) => event.preventDefault()

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('contextmenu', bloquear)
    document.addEventListener('copy', bloquear)
    document.addEventListener('cut', bloquear)
    document.addEventListener('dragstart', bloquear)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('contextmenu', bloquear)
      document.removeEventListener('copy', bloquear)
      document.removeEventListener('cut', bloquear)
      document.removeEventListener('dragstart', bloquear)
    }
  }, [enabled])
}
